/* keyedalike.com — the footer's contact form (sections/footer.liquid, the slip), on top of a plain Shopify contact form
   that works without this file: native required and type=email; the sent state, the email's message after a server
   error and the cart page's open fold are all rendered by Liquid.
   1. The Topic sets the message's example (its placeholder): each radio carries its own in data-example; General has
      none.
   2. The email is checked before the post (the form turns novalidate): blank or malformed puts its message under the
      field (the copy is the message line's data-blank / data-bad, the words Liquid prints after a server error),
      marks the field aria-invalid and focuses it, and the post waits. The message goes as soon as the address is
      right; it never appears while typing.
   3. "Rather write? Send us a message" in the call column ([data-to-form], its href the form's id) opens the cart
      page's fold, puts the cursor in the form's first field (or on the sent heading) and brings it into view, smoothly
      unless the visitor asks for reduced motion. A page opened at the form's #id opens the fold too.
   Idempotent: only the first copy of this file runs (window.kaFooter); every form and link is set up once
   (data-ka-ready), and a footer the theme editor re-renders is set up again (shopify:section:load). */
(() => {
  if (window.kaFooter) return;
  window.kaFooter = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /* the field "Rather write?" lands on: the sent heading, else the form's first field */
  const reveal = (form) => {
    const fold = form.closest('details');
    if (fold && !fold.open) fold.open = true;
    const target =
      form.querySelector('[data-sent-heading]') ||
      form.querySelector('input:not([type="hidden"]):not([disabled]), textarea, select');
    if (!target) return;
    target.focus({ preventScroll: true });
    target.scrollIntoView({ block: 'center', behavior: reduce.matches ? 'auto' : 'smooth' });
  };

  const setUpForm = (form) => {
    if (form.dataset.kaReady) return;
    form.dataset.kaReady = 'true';

    /* a page opened at the form (#FooterContact, as "Send another message" links) opens the cart page's fold */
    const fold = form.closest('details');
    if (fold && !fold.open && form.id && window.location.hash === '#' + form.id) {
      fold.open = true;
      form.scrollIntoView({ block: 'start' });
    }

    const email = form.querySelector('input[name="contact[email]"]');
    const message = form.querySelector('[data-email-error]');
    const body = form.querySelector('textarea[name="contact[body]"]');
    if (!email || !message) return; /* the sent state: nothing to check */

    /* 1. the topic's example */
    const syncTopic = () => {
      if (!body) return;
      const on = form.querySelector('input[name="contact[Topic]"]:checked');
      const example = on ? on.dataset.example : '';
      if (example) body.placeholder = example;
      else body.removeAttribute('placeholder');
    };
    form.addEventListener('change', (event) => {
      if (event.target.name === 'contact[Topic]') syncTopic();
    });
    syncTopic();

    /* 2. the email */
    const problem = (value) => {
      const address = value.trim();
      if (!address) return message.dataset.blank;
      if (!EMAIL.test(address)) return message.dataset.bad;
      return '';
    };
    const show = (text) => {
      message.textContent = text;
      message.hidden = !text;
      if (text) {
        email.setAttribute('aria-invalid', 'true');
        email.setAttribute('aria-describedby', message.id);
      } else {
        email.removeAttribute('aria-invalid');
        email.removeAttribute('aria-describedby');
      }
    };
    email.addEventListener('input', () => {
      if (email.getAttribute('aria-invalid') === 'true' && !problem(email.value)) show('');
    });
    /* In the capture phase, and a failed check stops the event: Shopify's hCaptcha binds the form on its first use
       with a submit listener of its own that always runs the captcha and then posts the form natively (no validation),
       which would send a blank or malformed address on to Shopify. */
    form.setAttribute('novalidate', '');
    form.addEventListener(
      'submit',
      (event) => {
        const text = problem(email.value);
        show(text);
        if (!text) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        email.focus();
      },
      true
    );
  };

  const setUpLink = (link) => {
    if (link.dataset.kaReady) return;
    link.dataset.kaReady = 'true';
    link.addEventListener('click', (event) => {
      const id = (link.getAttribute('href') || '').replace(/^#/, '');
      const form = id ? document.getElementById(id) : null;
      if (!form) return;
      event.preventDefault();
      reveal(form);
    });
  };

  const setUpAll = (root) => {
    root.querySelectorAll('.ka-footer form.pad-form').forEach(setUpForm);
    root.querySelectorAll('.ka-footer [data-to-form]').forEach(setUpLink);
  };
  setUpAll(document);
  document.addEventListener('shopify:section:load', (event) => setUpAll(event.target));
})();
